var _a;
// import * as PdfJsModern from "./modern/build/pdf"
import * as PdfJsLegacy from "./legacy/build/pdf";
let PdfJs = PdfJsLegacy;
// const pdfJsWorkerSrcGeneric = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${PdfJs.version}/pdf.worker.min.js`;
const pdfJsWorkerSrcGeneric = `/pdf.modern.worker.js`;
const pdfJsWorkerSrcLegacy = `/pdf.legacy.worker.js`;
let PdfJsWorkerSrc = pdfJsWorkerSrcLegacy;
PdfJs.GlobalWorkerOptions.workerSrc = pdfJsWorkerSrcGeneric;
const CMAP_URL = `//unpkg.com/pdfjs-dist@${PdfJs.version}/cmaps/`;
const CMAP_PACKED = true;
const isIos = ((_a = (process.env.REACT_APP_OS)) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "ios";
if (isIos) {
    PdfJs = PdfJsLegacy;
    PdfJsWorkerSrc = pdfJsWorkerSrcLegacy;
}
export { CMAP_PACKED, CMAP_URL, PdfJsWorkerSrc };
export default PdfJs;
//# sourceMappingURL=ImportPdfJs.js.map